import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "offcanvas-header mb-0" }
const _hoisted_3 = {
  type: "button",
  class: "btn-close text-reset",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close",
  ref: "closeFilter"
}
const _hoisted_4 = { class: "offcanvas-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "d-flex justify-content-start" }
const _hoisted_7 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_8 = ["checked", "id", "onClick"]
const _hoisted_9 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      role: "dialog",
      class: "offcanvas offcanvas-bottom",
      style: {"min-height":"30vh"},
      tabindex: "-1",
      ref: "offcanvasEl",
      id: _ctx.$props.idColumns,
      "aria-labelledby": "offcanvasTopLabel"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("h5", { id: "offcanvasTopLabel" }, "Seleção de Colunas do Grid", -1)),
        _createElementVNode("button", _hoisted_3, null, 512)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.grouped), (key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: _normalizeClass(["pe-4 me-2 me-2", { 'border-end border-end-3': Object.keys(_ctx.grouped).length > 1 }])
              }, [
                (Object.keys(_ctx.grouped).length > 1)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(key=='undefined'?"Principal": key), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grouped[key], (column) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "form-check",
                    key: column.datafield
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      checked: !column.hidden,
                      id: column.datafield,
                      onClick: ($event: any) => {column.hidden = (column.hidden ? false : true); _ctx.onClickCheckBox();}
                    }, null, 8, _hoisted_8),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: column.datafield
                    }, _toDisplayString(column.text), 9, _hoisted_9)
                  ]))
                }), 128))
              ], 2))
            }), 128))
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ]))
}